import jwtDecode from "jwt-decode";

export const getUser = () => {
	let user = null;
	const au = localStorage.getItem("au");
	au ? (user = jwtDecode(au)) : user;
	return user;
};
